import type { CommandWorkflow } from './types'

export const defineCommandWorkflow = <const PageId extends string>(
  workflow: CommandWorkflow<PageId>,
): CommandWorkflow<PageId> => workflow
